import { render, staticRenderFns } from "./listFooter.vue?vue&type=template&id=3a64f760&scoped=true&lang=pug&"
import script from "./listFooter.vue?vue&type=script&lang=js&"
export * from "./listFooter.vue?vue&type=script&lang=js&"
import style0 from "./listFooter.vue?vue&type=style&index=0&id=3a64f760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64f760",
  null
  
)

export default component.exports